import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_ID, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { QuicklinkModule } from 'ngx-quicklink';
import { RollbarErrorHandler, rollbarFactory, RollbarService } from '../rollbar_config';

import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';

/**
 * This is the first module loaded. It bootstraps
 * the rest of the application.
 */
@NgModule({ 
    declarations: [ AppComponent ]
    , bootstrap: [ AppComponent ]
    , imports: [
        BrowserModule
        , CoreModule
        , QuicklinkModule
        , BrowserAnimationsModule
        , ServiceWorkerModule.register(
            'ngsw-worker.js'
            , {
                enabled: true
                , registrationStrategy: 'registerWhenStable:30000'
            })
        ]
    , providers: [
        {
            provide: ErrorHandler
            , useClass: RollbarErrorHandler
        }
        , {
            provide: RollbarService
            , useFactory: rollbarFactory
        }
        , { 
            provide: APP_ID,  
            useValue: 'ng-cli-universal' 
        }
        , provideHttpClient(withInterceptorsFromDi())
    ] 
})
export class AppModule {}
